import React from "react";
import { RouteErrorBoundary } from "@/components/routing/RouteErrorBoundary";

// Authentication routes have been removed
export const authRoutes = [];